//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Autocomplete from 'vue2-autocomplete-js';

import uniqid from 'uniqid';
import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'

const stringOptions = [
  'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
  ].reduce((acc, opt) => {
  for (let i = 1; i <= 5; i++) {
    acc.push(opt + ' ' + i)
  }
  return acc
}, [])

export default {
    components: {
          Autocomplete,
    },    
    data () {
        return { 
            token : localStorage.token,
            current: 3, 
            dense: true, 
            nama_prov: '', 
            nama_kab: '', 
            form : {
              id : '',
              m_provinsi : '',
              m_kabupaten : '',
              m_kecamatan : '',
              kd_kecamatan : '',
              uraian : '',
              createdAt : '',
              uniqid : ''
            },

            list_data : [],

            page_limit : 8,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,

            UMUM : UMUM,
            WILAYAH : WILAYAH,

        }
    },
    methods: {
      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_DATAMASTER_KECAMATAN + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data.data);
        });
      },


      addData : function(number) {
        this.form.uniqid = uniqid();
        this.form.id = this.form.uniqid;
        this.form.m_kecamatan = uniqid();
        this.form.createdAt = UMUM.NOW();

        fetch(this.$store.state.url.URL_DATAMASTER_KECAMATAN + "addData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.$store.commit('notif_berhasil')
            this.getView();
        });


      },


      editData : function(){
        this.form.m_kecamatan = this.form.m_kecamatan;

        fetch(this.$store.state.url.URL_DATAMASTER_KECAMATAN + "editData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.$store.commit('notif_edit');
            this.getView();
        });
      },

      removeData : function(data){
        fetch(this.$store.state.url.URL_DATAMASTER_KECAMATAN + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(data)
        }).then(res_data => {
            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        });

      },
      selectData : function(data){
          this.form.m_provinsi = data.m_provinsi.m_provinsi;
          this.form.m_kabupaten = data.m_kabupaten.m_kabupaten;
          this.form.id = data.m_kecamatan.id;
          this.form.kd_kecamatan = data.m_kecamatan.kd_kecamatan;
          this.form.m_kecamatan = data.m_kecamatan.m_kecamatan;
          this.form.uraian = data.m_kecamatan.uraian;
          this.form.createdAt = data.m_kecamatan.createdAt;
          this.form.uniqid = data.m_kecamatan.uniqid;

          this.WILAYAH.getKab(this.form.m_provinsi);

          this.nama_prov = data.m_provinsi.uraian;          
          this.nama_kab = data.m_kabupaten.uraian;          

      },

    // ====================================== filter autocomplete  
    renderChildProv(data) {
        return `
        <span><b>${data.kd_provinsi}</b></span>
        <span style='font-size:80%'>${data.uraian}</span>
        `
    },    
    renderChildKab(data) {
        return `
        <span><b>${data.kd_kabupaten}</b></span>
        <span style='font-size:80%'>${data.uraian}</span>
        `
    },    
    get_auto(data){
      console.log(data.kd_provinsi); 
      this.form.m_provinsi = data.m_provinsi  
    },        
    get_auto_kab(data){ 
      this.form.m_kabupaten = data.m_kabupaten 
      console.log(data.kd_kabupaten); 
    },        
    // ====================================== filter autocomplete  

    
    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },
        myFilter (terms, obj) {
          return obj.label.toLowerCase().indexOf(terms) > -1
        }, 


    // ====================================== PAGINATE ====================================
      filterFn (val, update, abort) {
        // call abort() at any time if you can't retrieve data somehow
        setTimeout(() => {
          update(
            () => {
              if (val === '') {
                this.options = stringOptions
              }
              else {
                const needle = val.toLowerCase()
                this.options = stringOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
              }
            },

            // next function is available in Quasar v1.7.4+;
            // "ref" is the Vue reference to the QSelect
            ref => {
              if (val !== '' && ref.options.length > 0) {
                ref.setOptionIndex(-1) // reset optionIndex in case there is something selected
                ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
              }
            }
          )
        }, 300)
      },      
      abortFilterFn () {
        // console.log('delayed filter aborted')
      },
      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
            return `${filesNumber} files of ${maxFiles} | ${totalSize}`
      },     
      CariData:function(){
        this.getView();
      },
    },


    mounted () {
      // this.WILAYAH.getProv();
      // this.WILAYAH.getKab();
      this.CariData();
    },
}
